import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 32, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ y }}
      whileInView={{ y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeader({ index, label, title, intro, testid }) {
  return (
    <div className="max-w-3xl">
      <p className="mb-5 flex items-center gap-3 font-mono text-[10px] font-semibold uppercase tracking-[0.35em] text-[#EB5E28]">
        <span className="h-px w-8 bg-[#EB5E28]/60" />
        {`[ ${index} — ${label} ]`}
      </p>
      <h2
        data-testid={testid}
        className="font-display text-3xl font-semibold leading-[1.1] tracking-[-0.02em] text-[#0F141A] sm:text-4xl lg:text-5xl"
      >
        {title}
      </h2>
      {intro && (
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#3B434E] sm:text-lg">{intro}</p>
      )}
    </div>
  );
}
